const hasExemptPlayer = [
    "cartola",
    "sysbet",
    "homolog",
    "jogodeourobet",
    "amabet",
    "betdasorte",
    "pingolbet",
    "pixpremioesporte",
    "bbsesportes",
    "betgol777",
    "betsuper",
    "deboa",
    "espetbet",
    "golacobet",
    "pixsorte",
    "placarbets",
    "popbet",
    "sabiobet",
    "sheik",
    "chutaco",
    "bet24hs",
    "topsports",
    "apostamaster",
    "betinterativovip",
    "placarxbet",
    "betgol",
    "confiancasports",
    "a3bet",
    "bets88",
    "8bets",
    "spinbet",
    "attack",
    "pokarbet",
    "betclub7",
    "sportshowpix",
    "bettoro",
    "betpremier",
    "faz1bet",
    "betpix",
    "pixbetbrasil",
    "soccer888",
    "pixbrasil",
    "sullbet",
    "betnaveia",
    "limasports",
    "imperialbetcom",
    "esportenet",
    "overbets",
    "caixabets",
    "podersports",
    "recpix",
    "pagamaissports",
    "oxebet",
    "nubet",
    "kbet",
    "radarbets",
    "mandala",
    "arenas",
    "betfolia",
    "nbet91",
    "pixlive",
    "trevosports",
    "donosdabola",
    "sbet355",
    "lancebet",
    "streetbet",
    "betdosertao",
    "pixcerto",
    "oficialbetgames",
    "g6games",
    "bolladasorte",
    "lotusbet",
    "18kbetonline",
    "boto",
    "aki",
    "coraesportes",
    "bellosports",
    "sportebet"
];

export default hasExemptPlayer;
